import { Icon } from "@iconify/react";
import type { ChatAttachment } from "../../api/getAttachments";
import { getFileIcon, getFileIconColor } from "../AttachmentsBar";

interface AttachmentItemProps {
  attachment: ChatAttachment;
  isDarkMode: boolean;
  onClick?: () => void;
}

export function AttachmentItem({ attachment, isDarkMode, onClick }: AttachmentItemProps) {
  return (
    <div
      className={[
        "grid",
        "grid-cols-[auto_1fr]",
        "items-center",
        "gap-3",
        "px-4",
        "py-3",
        "rounded-lg!",
        "w-full",
        "text-left",
        "transition-colors",
        onClick ? "cursor-pointer" : "",
        isDarkMode ? "bg-gray-700 hover:bg-gray-600" : "bg-gray-100 hover:bg-gray-200",
      ].join(" ")}
      title={attachment.filename}
      {...(onClick
        ? {
            role: "button",
            tabIndex: 0,
            onClick,
            onKeyDown: (e: React.KeyboardEvent) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onClick();
              }
            },
          }
        : {})}
    >
      <Icon
        icon={getFileIcon(attachment.mime_type)}
        className={`w-6 h-6 ${getFileIconColor(attachment.mime_type, isDarkMode)}`}
      />
      <div className="min-w-0">
        <span
          className={[
            "text-sm",
            "block",
            "truncate",
            "font-medium",
            isDarkMode ? "text-gray-300" : "text-gray-700",
          ].join(" ")}
        >
          {attachment.filename}
        </span>
        <span className={["text-xs", isDarkMode ? "text-gray-400" : "text-gray-500"].join(" ")}>
          {(attachment.size / 1024).toFixed(2)} KB
        </span>
      </div>
    </div>
  );
}
